
<div class="not-found-header">
	<app-register-header></app-register-header>
</div>

<section class="not-found-page" aria-labelledby="not-found-title">
	<div class="not-found-shell">
		<div class="not-found-card">
			<p class="error-code">404</p>
			<h1 id="not-found-title" class="error-title">Page not found.</h1>
			<p class="error-copy">Sorry, we can&rsquo;t find the page you are looking for.</p>
		</div>
	</div>
</section>